import * as React from "react";
import {
  Grid
,useTheme} from "@mui/material";
import {Link1, Title5} from "../../../domains/common/components/Typography";
import {useState} from "react";
import {
  additionalStatementTypesWMortgage, additionalStatementTypeTitleShort
} from "../../../dictionaries";
import Box from "@mui/material/Box";
import {useNotify} from "../../../domains/common/components/AlertNotify";
import {DealStatementTypes, RegistrationTypes} from "../../../enums";
import {ButtonGroupCustom} from "../../../domains/common/components/Button";
import {createChildDeal, dealData} from "../deal";
import { hasStatus } from "../status";
import { getKUVDParams } from "../rrevents";
import { Item } from "../../../domains/common/components/Item";
/**
 * @typedef FileValues
 * @type {Object}
 * @property {string} fileName
 * @property {string} fileDesc
 * @property {string} link
 * @property {string} type
 * @property {number} id
 */
export function ChildStatementList() {
  let [state, setState] = useState(dealData.childDeals);

  const {openNotify} = useNotify();

  const addNewChild = async (option) => {
    if (!option) {
      return;
    }
    
    const map = {
      [DealStatementTypes.ADDING_DOC_TO_REG]: RegistrationTypes.ADDITIONAL_STATEMENT,
      [DealStatementTypes.RETURN_WO_REG]: RegistrationTypes.ADDITIONAL_STATEMENT,
      [DealStatementTypes.SUSPEND_REG]: RegistrationTypes.ADDITIONAL_STATEMENT,
      [DealStatementTypes.RESUME_STATEMENT]: RegistrationTypes.ADDITIONAL_STATEMENT,
      [DealStatementTypes.MORTGAGE_REGISTRATION]: RegistrationTypes.MORTGAGE_REGISTRATION
    };
    
    const result = await createChildDeal(
      map[option],
      option
    )
    
    if(result.ok) {
      setState([...state, {id: result.data.id, statementType: option, type: map[option]}]);
    } else {
      openNotify({msg: result.message || 'При создании сделки произошла ошибка', duration: 3000, type: 'error'})
    }
  }
  
  const getChildDesc = (childDeal) => {
    let title = 'Дополнительное заявление';

    if (childDeal.statementType) {
      title = additionalStatementTypeTitleShort[childDeal.statementType];
    }
    
    if (childDeal.type === RegistrationTypes.REPAYMENT_MORTGAGE_REG_RECORD) {
      title = 'Дополнительное заявление о снятии обременения';
    }
    
    return (<Link1 target="_blank" color="text.link" href={`/deal?id=${childDeal?.id}`}>{title}</Link1>)
  }

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <Title5 title="Дополнительные заявления"/>
        </Grid>
        <Grid item xs={4}>
          <Box display="flex" justifyContent="flex-end">
            <AddChildStatementButton onClick={addNewChild}>Добавить</AddChildStatementButton>
          </Box>
        </Grid>
        <Grid item container xs={12} spacing={2}>
          {
            state.map((childDeal) => {
              return <Grid item xs={12}>{getChildDesc(childDeal)}</Grid>
            })
          }
        </Grid>
      </Grid>
    </div>
  )
}

export function AddChildStatementButton({onClick}) {
  const anchorRef = React.useRef(null);

  const handleClick = () => {};
  
  const handleMenuItemClick = (type) => {
    onClick(type)
    
    if (anchorRef.current) {
      return;
    }
  };

  return (
    <ButtonGroupCustom onButtonClick={handleClick} onMenuClick={handleMenuItemClick} options={additionalStatementTypesWMortgage}/>
  );
}

export const ChildStatmentContainer = () => {
    const theme = useTheme();
    let childStatementContainer = '';
    if(
      hasStatus('dealSentToRR') &&
      !!getKUVDParams()?.kuvdNumber
    ) {
      childStatementContainer = <Grid item xs={12}>
        <Item sx={{backgroundColor: theme.palette.background.default}}>
          <ChildStatementList/>
        </Item>
      </Grid>
    }
    return (
        childStatementContainer
    )
}